import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getQuarter/index.js';

var require$$25 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$25 as default };
